import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
import axios from 'axios';
Swiper.use([Navigation, Pagination, EffectFade]);

export default {
    slider: null,
    modalEl: document.querySelector('.r-modal'),
    clipboard: null,
    cleanData: true,
    sliderHtml:
        `<div class="r-gallery-slider _dark">
            <div class="swiper-wrapper"></div>
            <div class="r-news-slider__nav">
                <div class="r-news-slider__arrow _left">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0831 4.27147C12.4731 3.88094 12.4731 3.24778 12.0831 2.85725C11.6931 2.46673 11.0608 2.46673 10.6708 2.85725L4.3157 9.29265C3.92572 9.68317 3.92572 10.3163 4.3157 10.7069L10.6708 16.9994C11.0608 17.3899 11.6931 17.3899 12.0831 16.9994C12.4731 16.6089 12.4731 15.9757 12.0831 15.5852L7.43269 10.9998H17.7321C18.2836 10.9998 18.7307 10.6235 18.7307 9.99976C18.7307 9.44747 18.2836 8.99976 17.7321 8.99976L7.43269 8.99976L12.0831 4.27147Z" fill="#77798C"/>
                    </svg>
                </div>
                <div class="r-news-slider__pagination text-gray"></div>
                <div class="r-news-slider__arrow _right">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0831 4.27147C12.4731 3.88094 12.4731 3.24778 12.0831 2.85725C11.6931 2.46673 11.0608 2.46673 10.6708 2.85725L4.3157 9.29265C3.92572 9.68317 3.92572 10.3163 4.3157 10.7069L10.6708 16.9994C11.0608 17.3899 11.6931 17.3899 12.0831 16.9994C12.4731 16.6089 12.4731 15.9757 12.0831 15.5852L7.43269 10.9998H17.7321C18.2836 10.9998 18.7307 10.6235 18.7307 9.99976C18.7307 9.44747 18.2836 8.99976 17.7321 8.99976L7.43269 8.99976L12.0831 4.27147Z" fill="#77798C"/>
                    </svg>
                </div>
            </div>
        </div>`,
    show(el, modalType) {
        if (!el) return;

        document.body.classList.add('body-lock-scroll');
        this.modalEl.classList.add('_open');

        this.modalEl.querySelector('.r-modal__title')
            .innerHTML = el.dataset.title;
        this.addSocialLinks(el);
        this.initClipboard();
        setTimeout(() => {
            this.modalEl.classList.add('_animate');
        }, 300);
        this.initHide(modalType);

        switch (modalType) {
            case 'video':
                const href = el.dataset.href;
                const hrefCheck = /http[s]?:\/\//.test(href) ? href : 'https://' + href;

                this.modalEl.classList.add('r-modal-video');
                this.modalEl
                    .querySelector('.r-modal__content')
                    .innerHTML = `<iframe src="${hrefCheck}" width="100%" height="100%" frameborder="0"></iframe>`;
                break;
            case 'gallery':
                this.modalEl.querySelector('.r-modal__content')
                    .innerHTML = this.sliderHtml;
                this.initSlider(el);
                break;
        }
    },
    showNotNews(modalType) {
        document.body.classList.add('body-lock-scroll');
        this.modalEl.classList.add('_open');
        this.modalEl.classList.add('r-modal-' + modalType);

        setTimeout(function() {
            this.modalEl.classList.add('_animate');
        }, 300)
        this.initHide(modalType);
    },
    showDefault(modalType, title, content) {
        document.body.classList.add('body-lock-scroll');
        this.cleanData = false;
        this.modalEl.querySelector('.js-modal-title')
            .innerHTML = title;
        this.modalEl.querySelector('.js-modal-content')
            .innerHTML = content;
        this.modalEl.classList.add('_open');
        this.modalEl.classList.add('r-modal-' + modalType);

        setTimeout(function() {
            this.modalEl.classList.add('_animate');
        }, 300)
        this.initHide(modalType);
    },
    showInPageStart(obj) {
        const url = '/ajax/' + obj.type + '_item.php';

        axios.get(
            url,
            {
                params: {
                    'id': obj.id,
                },
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        ).then(({ data }) => {
            console.log('data', data)
            document.body.classList.remove('body-lock-scroll')
            this.modalEl.classList.add('_open');
            this.modalEl.querySelector('.r-modal__title')
                .innerHTML = data.dataset.title;
            this.addSocialLinks(data);

            switch (obj.type) {
                case 'video':
                    this.modalEl.classList.add('r-modal-video');
                    this.modalEl
                        .querySelector('.r-modal__content')
                        .innerHTML = `<iframe src="${data.dataset.href}" width="100%" height="100%" frameborder="0"></iframe>`;
                    break;
                case 'gallery':
                    this.modalEl.querySelector('.r-modal__content')
                        .innerHTML = this.sliderHtml;
                    this.initSlider(data);
                    break;
            }
        }).catch((err) => {
            console.error(url + ' error: ' + err);
        });

        this.initClipboard();
        setTimeout(function() {
            $('.r-modal').addClass('_animate').title
        }, 300)
        this.initHide(obj.type);
    },
    hide(type) {
        document.body.classList.remove('body-lock-scroll');
        this.modalEl.classList.remove('_animate');
        setTimeout(() => {
            this.modalEl.classList.remove('_open');
            if (this.cleanData) {
                this.modalEl.querySelector('.r-modal__title')
                    .innerHTML = '';
                this.modalEl.querySelector('.r-modal__content')
                    .innerHTML = '';
            }
        }, 500);

        switch (type) {
            case 'video':
                this.modalEl.classList.remove('r-modal-video');
                break;
            case 'gallery':
                this.slider.destroy();
                break;
        }
    },
    initHide(modalType) {
        const overlay = this.modalEl.querySelector('.r-modal__overlay');
        const closeButton = this.modalEl.querySelector('.r-modal__close');

        overlay.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide(modalType);
        });
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide(modalType);
        });
    },
    initSlider(el) {
        const slides = JSON.parse(el.dataset.list);
        const slidesContainer = this.modalEl.querySelector('.swiper-wrapper');

        slides.forEach((item) => {
            const itemNode = document.createElement('div');
            itemNode.classList.add('r-gallery-slider__slide');
            itemNode.classList.add('swiper-slide');
            itemNode.innerHTML =
                `<div class="r-gallery-slider__img"
                    style="background-image: url('${item.img}')"
                ></div>
                <div class="r-gallery-slider__title">
                    <span class="text-small text-white">${item.title}</span>
                </div>`;
            slidesContainer.appendChild(itemNode);
        });
        this.slider = new Swiper(this.modalEl.querySelector('.r-gallery-slider'),
            {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: this.modalEl.querySelector('.r-news-slider__pagination'),
                    type: 'fraction',
                },
                navigation: {
                    nextEl: this.modalEl.querySelector('.r-news-slider__arrow._right'),
                    prevEl: this.modalEl.querySelector('.r-news-slider__arrow._left'),
                },
            }
        );
    },
    addSocialLinks(el) {
        const items = this.modalEl.querySelectorAll('.r-socials a');
        const href = el.href;

        items.forEach(( item) => {
            switch (true) {
                case item.classList.contains('_fb'):
                    item.href = 'https://www.facebook.com/sharer/sharer.php?u=' + href;
                    break;
                case item.classList.contains('_vk'):
                    item.href = 'https://vk.com/share.php?url=' + href;
                    break;
                case item.classList.contains('_tg'):
                    item.href = 'https://t.me/share/url?url=' + href;
                    break;
                case item.classList.contains('_copy'):
                    item.href = href
                    break;
            }

        })
    },
    initClipboard: function() {
        const el = this.modalEl.querySelector('._copy');
        const notifyEl = el.querySelector('.copy-notification');

        el.addEventListener('click', (e) => {
            e.preventDefault();

            navigator.clipboard.writeText(el.href);
            notifyEl.classList.add('_show');
            setTimeout(() => {
                notifyEl.classList.remove('_show');
            }, 1500)
        })
    }
}
